import React, {useEffect, useState} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import {
  addToGlobalStyles,
  setGlobalStyles,
  setIsLanguageSelected,
  setWizard,
  setLanguage,
} from '../../../store/actions';
import './styles.scss';
import colors, {pageBackgrounds} from '../../../util/colors';
import Header1 from '../../../components/headers/header1';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import AppButton from '../../../components/app-button';
import {useHistory} from 'react-router-dom';
import {ITenant} from '../../../App';
import AuthorizedImage from '../../../components/images';
import {createGUID} from '../../../util/utility';

interface RegisterCompletedProps {
  addToGlobalStyles(value: any): any;
  setGlobalStyles(value: any): any;
  setWizard(value: any): any;
  setIsLanguageSelected(value: boolean): void;
  globalStyles: any;
  setLanguage(value: boolean): void;
  labels: typeof strings.pt.register;
  labelsMessages: typeof strings.pt.messages;
  languageOptions: any;
  tenant: ITenant;
}

function RegisterCompleted({
  addToGlobalStyles,
  setGlobalStyles,
  setWizard,
  setIsLanguageSelected,
  setLanguage,
  globalStyles,
  labels,
  languageOptions,
  tenant,
  labelsMessages,
}: RegisterCompletedProps) {
  useEffect(() => {
    addToGlobalStyles({background: pageBackgrounds.loginPage});
    setWizard({});
  }, []);

  const history = useHistory();

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-completed-container">
        <Row className="register-completed-title-1">
          <Header1
            style={{color: colors.black, fontWeight: 'bold'}}
            className="register-completed-header">
            {labels?.registerComplete_title}
          </Header1>
          <Header1
            style={{...fonts.L, color: colors.black, fontWeight: 'bold'}}
            className="register-completed-header-responsive">
            {labels?.registerComplete_title}
          </Header1>
        </Row>
        <Row>
          <Header1
            style={{color: colors.black, fontWeight: 'bold'}}
            className="register-completed-header">
            {labels?.registerComplete_title2}
          </Header1>
          <Header1
            style={{...fonts.L, color: colors.black, fontWeight: 'bold'}}
            className="register-completed-header-responsive mb-0">
            {labels?.registerComplete_title2}
          </Header1>
        </Row>
        <Row>
          <AuthorizedImage
            requiresAuthorization={false}
            className="register-completed-image"
            source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${tenant.registerSuccessImage}`}
          />
        </Row>
        <br />
        <Row>
          <div style={{...fonts.ML, color: colors.black}}>
            {labels?.registerComplete_canLogin}
          </div>
        </Row>
        <Row>
          <AppButton
            className="register-completed-login-button"
            onClick={() => {
              setIsLanguageSelected(false);
              setLanguage(
                languageOptions?.find(
                  (option: any) =>
                    option.indexOf(navigator.language?.split('-' || '_')[0]) >
                    -1
                ) ||
                  labelsMessages?.default_language ||
                  (process.env.REACT_APP_DEFAULT_TENANT_ALIAS === 'RS'
                    ? 'rs-RS'
                    : 'pt-PT')
              );
              history.push('/');
            }}>
            {labels?.registerComplete_buttonText}
          </AppButton>
        </Row>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({
  strings,
  stringsDefault,
  globalStyles,
  languageOptions,
  tenant,
}: any) => ({
  labels: strings.value.pt.register,
  labelsMessages: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  languageOptions: languageOptions.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIsLanguageSelected: (value: boolean) =>
    dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: boolean) => dispatch(setLanguage(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(RegisterCompleted)
);
